module.exports = __webpack_public_path__ + "static/media/img4.9eb40c9b.png";